<div class="flex flex-col justify-between w-full pt-4 px-6 bg-primary-accumin-white rounded-t-lg">
  <div class="flex flex-row items-center justify-between">
    <div class="flex flex-row items-center">
      <mat-icon svgIcon="icn-layers" class="mat-icon-svg-color-accumin-purple" />

      <h3 class="text-primary-accumin-black-100 break-words !ml-2 !mb-0 !my-0">
        {{ "Title.MainTitle.Layer.ModuleName" | transloco }}
      </h3>
    </div>

    <div class="flex flex-row items-center">
      @if (canMinimize()) {
        <button mat-icon-button (click)="minimizeModule.emit()">
          <mat-icon class="mat-icon-svg-color-accumin-black-50" svgIcon="icn-minimized-collapsed" />
        </button>
      }

      <button mat-icon-button (click)="closeModule.emit()">
        <mat-icon svgIcon="icn-close" class="mat-icon-svg-color-accumin-black-50" />
      </button>
    </div>
  </div>

  <mat-divider class="!my-4" />
</div>
